import { QueryClient } from '@tanstack/react-query';
import { LIST_ITEMS_COUNT } from '@/constants/lists.constants';
import { partnerProvidersQueries } from '@/queries/partner-providers';

export const partnerProviderLoader = (queryClient: QueryClient) => () => {
  return queryClient.ensureQueryData(partnerProvidersQueries.list({ itemsPerPage: LIST_ITEMS_COUNT, pageIndex: 0 }));
};

export const partnerProviderByIdLoader = (queryClient: QueryClient) => (logisticProviderId: string) => {
  return queryClient.ensureQueryData({
    ...partnerProvidersQueries.item(logisticProviderId),
    revalidateIfStale: true,
  });
};
